import axios from "axios";
import swal from 'sweetalert';
import { getProductApi } from "../../../hooks/useFerch";
import { siteURL, cartlink } from "../../../utils/constants";


export default function Addcart(user,product, idProductoPadre) {

   //console.log(user,product, idProductoPadre );

   if(idProductoPadre){
   // console.log(idProductoPadre);
    (async () => {
      //  var nombreProducto = array();
        const response = await getProductApi(idProductoPadre);   
          let nameR = response.attributes[0].name;
         let minuscula = nameR.toLowerCase();
         var variableA = minuscula.replace(/\s+/g, '-')

         const respondP = await getProductApi(product);
          const nameAtributo = respondP.attributes[0].option;
          const nameParaAgregar =  `"attribute_pa_${variableA}"`
   


      let link = `${siteURL}${cartlink}`;
       var qs = require('qs');
       var data = qs.stringify({
       'cart_key': user,
       'product_id': product,
       'quantity': '1',
       "variation": {
        nameParaAgregar : nameAtributo,
      },
       'return_cart': 'true' 
       });
       var config = {
         method: 'post',
         url: link,
         headers: { 
           'Content-Type': 'application/x-www-form-urlencoded'
         },
         data : data
       };
       
       axios(config)
       .then(function (response) {
        if(response.data){
           return swal({
               title: "Listo",
               text: "Producto añadido al carrito",
               icon:"success",
               button:"Aceptar",
               timer:"2200"
           });
        }

       })
       .catch(function (error) {
          console.log(error);
          return swal({
           title: "Error",
           text: "No se pudo añadir el producto al carrito",
           icon:"error",
           button:"Aceptar",
           timer:"2200"
          });
     });
      }
      
      
      )();


   }else{

    const iduser = user;
    const idProduct = product;


      let link = `${siteURL}${cartlink}`;
       var qs = require('qs');
       var data = qs.stringify({
       'cart_key': iduser,
       'product_id': idProduct,
       'quantity': '1',
       'return_cart': 'true' 
       });
       var config = {
         method: 'post',
         url: link,
         headers: { 
           'Content-Type': 'application/x-www-form-urlencoded'
         },
         data : data
       };
       
       axios(config)
       .then(function (response) {
        if(response.data){
           return swal({
               title: "Listo",
               text: "Producto añadido al carrito",
               icon:"success",
               button:"Aceptar",
               timer:"2200"
           });
        }

       })
       .catch(function (error) {
          console.log(error);
          return swal({
           title: "Error",
           text: "No se pudo añadir el producto al carrito",
           icon:"error",
           button:"Aceptar",
           timer:"2200"
          });
     });
   
   }

     
    


   
    
}